// extracted by mini-css-extract-plugin
module.exports = {"base":"AGjrwA","text":"_34I6Vw","icon":"_1OP5Rd"};